<template>
  <el-dialog
    title="作业管理"
    :visible.sync="showHomeWork"
    width="50%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    @closed="handleClose"
    class="homeWork"
    :close-on-click-modal="false"
  >
    <el-table ref="refTable" @row-click="expandRow" style="width: 100%" :data="tableData" :row-class-name="rowClassName">
      <el-table-column type="expand">
        <template slot-scope="{row}">
          <el-form label-position="left" class="row" label-width="110px">
            <el-form-item label="时间">
              {{ row.created_at|parseTime}}
            </el-form-item>
            <el-form-item label="标题">
              {{ row.title }}
            </el-form-item>
            <el-form-item label="完成人数">
              {{ row.completed }}(<label class="link" @click="handleViewCompeleted(row)">查看作业</label>)
            </el-form-item>
            <el-form-item label="未完成人数">
              {{activeNum,row.completed|doSubtra}}(<label class="link" @click="handleViewInCompelete(row)">查看名单</label>)
            </el-form-item>
            <el-form-item label="内容">
              {{row.content}}
            </el-form-item>
            <el-form-item label="附件">
              <div class="item" v-for="x in row.Attachments">
                <ul  @click="previewWord(x)" class="el-upload-list el-upload-list--text">
                  <li tabindex="0" class="el-upload-list__item is-success">
                    <a class="el-upload-list__item-name">
                      <i class="el-icon-document"></i>
                      {{x.name}}
                    </a>
                  </li>
                </ul>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="时间" width="170px" show-overflow-tooltip>
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}
        </template>
      </el-table-column>
      <el-table-column label="标题" align="center" prop="title" show-overflow-tooltip>

      </el-table-column>
      <el-table-column label="完成人数" align="center" prop="completed">
      </el-table-column>
      <el-table-column label="未完成人数" align="center" >
        <template slot-scope="{row}">
          {{activeNum,row.completed|doSubtra}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <axj-button-v2
            button-color="bread"
            button-size="medium"
            button-icon="del1"
            @click="handleDelete(row)"
          ></axj-button-v2>
          <axj-button-v2
            @click="handleUpdate(row)"
            button-icon="edit1"
          ></axj-button-v2>
        </template>
      </el-table-column>
    </el-table>
    <completed
      :show-completed.sync="compeleted.show"
      @close="handleCompeletedClose"
      :data="compeleted.data"
    />
    <incomplete
      @close="handleIncompleteClose"
      :show-in-completed.sync="inCompeleted.show"
      :data="inCompeleted.data"
    />
    <axj-file-preview
      :show-preview.sync="preview.show"
      :preview-file-type="preview.previewFileType"
      :preview-files="preview.previewFiles"
    />
    <home-work-edit
      :show.sync="homeworkAction.show"
      :is-create="homeworkAction.isCreate"
      :source="homeworkAction.content"
      @create="handleCreateHomework"
      @update="handleUpdateHomework"
    />
  </el-dialog>
</template>

<script>
import Completed from "./component/completed/index";
import Incomplete from "./component/incomplete/index";
import commonModels from '@/common/models/common-models'
import {getHomeSubmits,listCourseSelecter,deleteAssistantCourseHomework,createAssistantCourseHomework,updateAssistantCourseHomework,createAssistantCourseAttachment,deleteAssistantCourseAttachment,deleteAssistantCourseAttachments} from '@/api/axj-help/axj-help-course.js'
import HomeWorkEdit from "./component/home-work-edit/index";
export default {
  name: "home-work",
  components: {HomeWorkEdit, Incomplete, Completed},
  props:{
    showHomeWork:{
      type:Boolean,
      default:false
    },
    data:{
      type:Array,
      default:[]
    },
    activeNum:{
      type:Number,
      default:0
    },
    id: {
      type: Number,
      default: 0
    },
    row:{
      type:Object,
      default:()=>{
      }
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D h:m:s')
    },
    doSubtra(x,y){
      return x-y
    }
  },
  data(){
    return{
      homeworkAction: {
        id: 0,
        content: {},
        show: false,
        isCreate: true
      },
      preview:{
        show:false,
        previewFileType:'word',
        previewFiles:[]
      },
      compeleted:{
        show:false,
        data:[]
      },
      inCompeleted:{
        show:false,
        data:[]
      },
      hasLoadRow:[],
      tableData:[],

    }
  },
  watch:{
    data(v){
      this.tableData=v
    }
  },
  methods:{
    expandRow(row,index,e){
      let target=e.target
      if(target.className.indexOf('cell')==0||target.className.indexOf('el-tag')==0||target.className.indexOf('el-table')==0){
        this.$refs.refTable.toggleRowExpansion(row)
        return
      }
    },
    async handleDelete(val){
      await deleteAssistantCourseHomework(
        val.id
      )
      this.$emit('updateSuccess',this.row)
    },
    handleUpdate(val) {
      this.homeworkAction.id = val.id
      this.homeworkAction.content = JSON.parse(JSON.stringify(val))
      this.homeworkAction.isCreate = false
      this.homeworkAction.show = true
    },
    handleCreateHomework(val, fileList) {
      if(this.id) {
        createAssistantCourseHomework(val)
          .then(async (res)=> {
            await this.handleCreateHomework2Attachment(fileList, this.id, res.id)
            this.initData()
            this.homeworkAction.show = false
          })
          .catch(err=> {
            console.log(err)
          })
      }
    },
    handleUpdateHomework(val, fileList, removeList) {
      this.$delete(val, 'created_at')
      this.$delete(val, 'updated_at')
      this.$delete(val, 'Attachments')
      this.$delete(val,'completed')
      if(this.id) {
        updateAssistantCourseHomework(val)
          .then(async (res)=> {
            // 有删除的部分先删除
            if(removeList.length) {
              await this.handleRemoveHomeworkAttachment(removeList)
            }
            await this.removeHomeworkAttachment2(val.id);
            await this.handleCreateHomework2Attachment(fileList, this.id, this.homeworkAction.id)
            this.$emit('updateSuccess',this.row)
            this.homeworkAction.show = false
          })
          .catch(err=> {
            console.log(err)
          })
      }
    },
    handleCreateHomework2Attachment(fileList, cid, hid) {
      return new Promise((resolve, reject)=> {
        fileList.forEach(async (item) => {
          let homework = {
            course_id: cid,
            homework_id: hid,
            user_id: this.info.id,
            user_name: this.info.nickname,
            user_avatar: this.info.avatar,
            name: item.name,
            type: item.type,
            url: item.url.indexOf('http')>=0?item.url.slice(this.resourcePrefix.url.length):item.url,
          }
          await this.createHomeworkAttachment(homework)
        })
        resolve()
      })
    },
    createHomeworkAttachment(homework) {
      return new Promise((resolve, reject)=> {
        createAssistantCourseAttachment(homework)
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleRemoveHomeworkAttachment(removeList) {
      return new Promise((resolve, reject)=> {
        removeList.forEach(async (item)=> {
          await this.removeHomeworkAttachment(item)
        })
        resolve()
      })
    },
    removeHomeworkAttachment2(id){
      return new Promise((resolve, reject)=> {
        deleteAssistantCourseAttachments({
          where:JSON.stringify({
            homework_id: id
          })
        })
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    // 通过id 一个个的删除
    removeHomeworkAttachment(id) {
      return new Promise((resolve, reject)=> {
        deleteAssistantCourseAttachment(id)
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    previewWord(x){
      if(x.type!='image'&&x.type!='word'&&x.type!='png'&&x.type!='jpg'){
        window.open(this.preViewUrl+x.url)
        return
      }
      this.preview.previewFileType=x.type
      if(x.type=='png'||x.type=='jpg'){
        this.preview.previewFileType='image'
      }
      this.preview.previewFiles=[]
      this.preview.previewFiles.push({
        url:x.url
      })
      this.preview.show=true
    },
    rowClassName({row,rowIndex}){
      if(this.hasLoadRow.indexOf(rowIndex)==-1){
        row.index=rowIndex
      }
    },
    handleCompeletedClose(){
      this.compeleted.show=false
    },
    handleIncompleteClose(){
      this.inCompeleted.show=false
    },
    async handleViewInCompelete(row){
      let data=await new Promise((resolve,reject)=>{
        listCourseSelecter({
          where:JSON.stringify({
            course_id:row.course_id
          }),
          preload:true
        }).then(res=>{
          let result=[]
          let data=res.data.lists
          for(let x=0;x<data.length;x++){
            result.push(
              data[x].User
            )
          }
          getHomeSubmits({
            where:JSON.stringify({
              homework_id:row.id
            })
          }).then(rres=>{
            let data1=rres.data.lists
            for(let x=0;x<data1.length;x++){
              for(let y=0;y<result.length;y++){
                if(data1[x].user_id==result[y].id){
                  result.splice(y,1)
                }
              }
            }
            resolve(result)
          })
        })
      })


      this.inCompeleted.data=data
      this.inCompeleted.show=true
    },
    async handleViewCompeleted(row) {
      let data=await this.listCompeleted(row)
      this.compeleted.data=data.data.lists
      this.compeleted.show = true
    },

    listCompeleted(row){
       return new Promise((resolve,reject)=>{
         getHomeSubmits({
           where:JSON.stringify({
             homework_id:row.id
           })
         }).then(res=>{
           resolve(res)
         })
       })
    },
    handleOpen(){

    },
    handleClose(){
      this.tableData=[]
      this.hasLoadRow=[]
      this.$emit("close",false)
    },
  },
  computed: {
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    },
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
}
</script>

<style slot-scope lang="scss">
.homeWork{
  .row{
    margin-left: 10px;
    .link{
      color: #00adb5;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/home-work/index.vue